import React from 'react';
import { string, arrayOf } from 'prop-types';
import { translate } from 'react-i18next';
import { TextButton, Proportion } from 'wix-style-react';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import s from './serviceCategory.scss';
import { ARENA_EXPLORE_URL } from '../../../utils/constants';
import { baseURL } from '../../../fromWindow';

const ServiceCategory = ({
  t,
  services,
  staticsBaseUrl,
  categoryId,
  onServiceClick,
  onCategoryClick,
}) => {
  return (
    <div className={s.root}>
      <Proportion aspectRatio={278 / 198}>
        <div
          className={`${s.image} ${s[categoryId]}`}
          onClick={() => onCategoryClick(categoryId)}
          data-hook={`zero-state-category-${categoryId}`}
          aria-hidden={true}
        >
          <img
            src={`${staticsBaseUrl}/assets/images/hire/${categoryId}.jpg`}
            alt=""
          />
        </div>
      </Proportion>
      <div className={s.categoryTitleContainer}>
        <h4 className={s.categoryTitle}>
          <a
            className={s.categoryTitleLink}
            onClick={() => {
              onCategoryClick(categoryId);
              return false;
            }}
            href={`${baseURL}${ARENA_EXPLORE_URL}/${categoryId}`}
          >
            {t(`client-exploreexperts-${categoryId}-cta`)}
          </a>
        </h4>
      </div>
      <ul>
        {services.map(serviceId => (
          <li key={serviceId}>
            <TextButton
              className={s.link}
              as="button"
              onClick={() => onServiceClick(serviceId)}
              prefixIcon={<ChevronRight />}
              weight="normal"
            >
              {t(`client-exploreexperts-${serviceId}-cta`)}
            </TextButton>
          </li>
        ))}
        <li key={categoryId}>
          <TextButton
            className={s.link}
            as="button"
            onClick={() => onCategoryClick(categoryId)}
            prefixIcon={<ChevronRight />}
            weight="normal"
          >
            {t(`client-exploreexperts-zerostate-${categoryId}-all`)}
          </TextButton>
        </li>
      </ul>
    </div>
  );
};

ServiceCategory.propTypes = {
  categoryId: string.isRequired,
  services: arrayOf(string).isRequired,
};

export default translate()(ServiceCategory);
